import React from 'react'
import AllCategories from '../components/categories/AllCategories'
import SubCategoriesWrapper from '../components/categories/SubCategoriesWrapper'
import HomeBanner from '../components/banner/HomeBanner'
function Home() {
  return (
    <>
            {/* <AllCategories /> */}
            <HomeBanner src="homeBanner.png"/>
            <SubCategoriesWrapper slug="Toilet_Cleaner" type="subcategory" sub_category_name="Toilet Cleaner" />
            <SubCategoriesWrapper slug="Floor_Cleaner"  type="subcategory" sub_category_name="Floor Cleaner" />
            <HomeBanner src="BeforeNewLaunches.png"/>
            <SubCategoriesWrapper slug="latest"         type="latest"      sub_category_name="New Launches at Apsensys Care" />
            <SubCategoriesWrapper slug="Hand_Wash"      type="subcategory" sub_category_name="Hand Wash" />
            {/* <SubCategoriesWrapper slug="Body_Wash"      type="subcategory" sub_category_name="Body Wash" /> */}
            </>
  )
}

export default Home